import { API_BASE_URL } from '../Backend/ApiCalls';

export const resolveSponsorImage = (value) => {
  const source = String(value || '').trim();
  if (!source) return '';
  if (/^(https?:|data:|blob:)/i.test(source)) return source;
  if (source.startsWith('/gallery/') || source.startsWith('/media/')) return `${API_BASE_URL}${source}`;
  return source.startsWith('/') ? source : `/${source}`;
};

const extractLegacyMapUrl = (value) => {
  const source = String(value || '').trim();
  if (!source) return '';
  const match = source.match(/https?:\/\/[^"'\s]+/i);
  return match?.[0] || '';
};

export const sponsorMaps = (sponsor = {}) => {
  const latitude = Number(sponsor.latitude);
  const longitude = Number(sponsor.longitude);
  const hasCoordinates = Number.isFinite(latitude) && Number.isFinite(longitude);
  const query = hasCoordinates
    ? `${latitude},${longitude}`
    : String(sponsor.address || sponsor.name || '').trim();
  const legacy = extractLegacyMapUrl(sponsor.mapUrl);
  const safeLegacy = /^https:\/\/(www\.)?google\.[^/]+\/maps\//i.test(legacy)
    || /^https:\/\/maps\.google\.[^/]+\//i.test(legacy);

  return {
    embedUrl: safeLegacy ? legacy : (query ? `https://www.google.com/maps?q=${encodeURIComponent(query)}&output=embed` : ''),
    externalUrl: query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : '',
  };
};

export const sponsorHasPromotion = (sponsor = {}) =>
  sponsor.hasPromotion === true
  || sponsor.hasPromotion === 'true'
  || (sponsor.hasPromotion === undefined && Boolean(
    String(sponsor.promotion || '').trim()
    || sponsor.startDate
    || sponsor.endDate
    || sponsor.description
    || sponsor.conditions
  ));

export const safeSponsorWebsite = (value) => {
  const source = String(value || '').trim();
  return /^https?:\/\//i.test(source) ? source : '';
};
